var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessengerGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 100,
    viewBox: "0 0 232 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-group_svg__filter0_dd_11108_34950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 54c13.255 0 24-10.745 24-24S93.255 6 80 6 56 16.745 56 30s10.745 24 24 24z",
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 5.25c13.669 0 24.75 11.081 24.75 24.75S93.669 54.75 80 54.75 55.25 43.669 55.25 30 66.331 5.25 80 5.25z",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 29c0 5.799-4.701 10.5-10.5 10.5-2.212 0-4.264-.684-5.956-1.852l-3.59.897.941-3.526A10.452 10.452 0 0169 29c0-5.799 4.701-10.5 10.5-10.5S90 23.201 90 29z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5 41.25c6.766 0 12.25-5.484 12.25-12.25 0-6.765-5.484-12.25-12.25-12.25S67.25 22.235 67.25 29c0 2.197.578 4.259 1.591 6.042L67.25 41.25l6.4-1.484a12.195 12.195 0 005.85 1.484zm0-1.885c5.725 0 10.365-4.64 10.365-10.365 0-5.725-4.64-10.365-10.365-10.365-5.725 0-10.365 4.64-10.365 10.365 0 2.21.691 4.259 1.87 5.941l-.928 3.482 3.543-.886a10.318 10.318 0 005.88 1.828z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.438 23.313c-.292-.585-.739-.534-1.19-.534-.807 0-2.064.966-2.064 2.765 0 1.474.649 3.087 2.837 5.5 2.112 2.33 4.887 3.534 7.19 3.493 2.305-.041 2.779-2.023 2.779-2.693 0-.297-.184-.445-.311-.485-.785-.377-2.233-1.079-2.563-1.21-.33-.133-.501.046-.608.143-.299.285-.891 1.124-1.094 1.313-.203.188-.505.093-.63.021-.464-.185-1.719-.744-2.72-1.714-1.237-1.2-1.31-1.612-1.543-1.98-.186-.293-.05-.473.02-.552.266-.308.634-.783.799-1.019.165-.236.034-.594-.045-.817-.338-.96-.624-1.764-.858-2.232z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-group_svg__filter1_dd_11108_34950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 54c13.255 0 24-10.745 24-24S165.255 6 152 6s-24 10.745-24 24 10.745 24 24 24z",
    fill: "#7A5AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 5.25c13.669 0 24.75 11.081 24.75 24.75S165.669 54.75 152 54.75 127.25 43.669 127.25 30 138.331 5.25 152 5.25z",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 39.304c-.706 0-1.367-.024-1.987-.074l-2.964 3.494a.374.374 0 01-.659-.24v-3.988c-3.49-1.31-4.676-4.24-4.676-8.987 0-6.715 2.374-9.795 10.286-9.795 7.912 0 10.286 3.08 10.286 9.795s-2.374 9.795-10.286 9.795z",
    fill: "#7A5AF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.5 29.467c0-7.861-2.769-11.467-12-11.467s-12 3.606-12 11.467c0 5.595 1.403 9.034 5.538 10.553v2.646c0 .975 1.223 1.42 1.856.676l2.134-2.507c.767.067 1.59.1 2.472.1 9.231 0 12-3.607 12-11.468zm-13.962 9.56c.612.049 1.265.073 1.962.073 7.811 0 10.154-3.03 10.154-9.633s-2.343-9.632-10.154-9.632-10.154 3.029-10.154 9.632c0 4.668 1.171 7.55 4.616 8.838v3.921c0 .342.428.498.651.237l2.925-3.436z",
    fill: "#FAFAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.776 22.286c-.259 0-.47.198-.47.442s.211.442.47.442c3.116 0 5.641 2.377 5.641 5.31 0 .244.21.442.47.442s.47-.198.47-.443c0-3.42-2.946-6.193-6.581-6.193z",
    fill: "#FAFAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.76 23.729c.266-.129.735-.194 1.004.042.336.294.855.811 1.211 1.262.356.451.854 1.138.925 1.29.071.153.15.694-.206 1.02-.284.26-.656.492-.806.576a.74.74 0 00-.167.888c.254.54.799 1.602 1.741 2.393.941.79 1.938 1.207 2.563 1.339.04 0 .091.008.15.019.212.037.527.092.799-.179.279-.277.533-.569.625-.68.145-.148.567-.4 1.092-.222.656.222 1.408.708 1.748.937.272.183.878.617 1.147.811a.744.744 0 01.222.93c-.269.576-1.416 1.845-2.445 1.845-.379 0-4.05-.978-7.294-3.739-2.071-1.763-3.855-4.823-4.161-5.854-.116-.245-.253-.85.127-1.305.38-.455.807-.929 1.725-1.373z",
    fill: "#FAFAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.776 25.825c-.259 0-.47.198-.47.442 0 .245.211.443.47.443 1.039 0 1.881.792 1.881 1.77 0 .244.21.442.47.442.259 0 .47-.198.47-.443 0-1.466-1.263-2.654-2.821-2.654z",
    fill: "#FAFAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.306 24.498c0-.245.211-.443.47-.443 2.596 0 4.701 1.981 4.701 4.424 0 .245-.21.443-.47.443s-.47-.198-.47-.443c0-1.954-1.684-3.539-3.761-3.539-.259 0-.47-.198-.47-.442z",
    fill: "#FAFAFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#messenger-group_svg__filter2_dd_11108_34950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 58c15.464 0 28-12.536 28-28S131.464 2 116 2 88 14.536 88 30s12.536 28 28 28z",
    fill: "#2E90FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 1.25c15.878 0 28.75 12.872 28.75 28.75S131.878 58.75 116 58.75 87.25 45.878 87.25 30 100.122 1.25 116 1.25z",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.674 29.704c8.163-3.556 13.606-5.9 16.329-7.033 7.776-3.235 9.392-3.796 10.445-3.815.232-.004.75.053 1.085.326.283.23.361.54.399.758.037.218.083.714.046 1.102-.421 4.428-2.244 15.172-3.172 20.13-.392 2.099-1.165 2.803-1.913 2.871-1.626.15-2.861-1.074-4.436-2.106-2.464-1.616-3.857-2.621-6.249-4.198-2.764-1.822-.972-2.823.603-4.46.413-.428 7.577-6.944 7.716-7.535.017-.074.033-.35-.131-.495-.163-.146-.405-.096-.579-.056-.247.056-4.184 2.658-11.811 7.806-1.117.767-2.13 1.141-3.036 1.122-1-.022-2.923-.566-4.353-1.03-1.753-.57-3.147-.872-3.026-1.84.064-.504.758-1.02 2.083-1.547z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "messenger-group_svg__filter0_dd_11108_34950",
    x: 34.5,
    y: 4.5,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_11108_34950",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_11108_34950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "messenger-group_svg__filter1_dd_11108_34950",
    x: 106.5,
    y: 4.5,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_11108_34950",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_11108_34950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "messenger-group_svg__filter2_dd_11108_34950",
    x: 66.5,
    y: 0.5,
    width: 99,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_11108_34950",
    result: "effect2_dropShadow_11108_34950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_11108_34950",
    result: "shape"
  })))));
}

export default SvgMessengerGroup;